import { useMutation, useQuery } from "@tanstack/react-query";
import { displaySuccess } from "components/Toast/toast.component";
import GlimpseCard from "components/card/card.component";
import PaymentScreen from "components/stripe-elements/payment.screen";
import { IRenewSubscription } from "interfaces/subscription.interface";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { logout } from "services/auth.service";
import { getClientSecret } from "services/payment.service";
import { getEndUserData } from "services/setting.service";
import Button from "components/button/button";
import Loading from "components/loading/loading.component";

const RenewSubscription: React.FC<IRenewSubscription> = ({ dialogue }) => {
  const [openPayment, setOpenPayment] = useState<boolean>(false);
  const navigate = useNavigate();
  const { data: paymentData, status } = useQuery({
    queryKey: ["getClientSecret"],
    queryFn: getClientSecret,
    refetchOnWindowFocus: false,
    retry: 0
  });

  const { data: endUserInfo, refetch } = useQuery({
    queryKey: ["getEndUserData"],
    queryFn: getEndUserData,
    refetchOnWindowFocus: false,
    enabled: false,
    retry: 0,
  });

  useEffect(() => {
    if (endUserInfo) {
      const localStorageValue = localStorage.getItem("userInfo");
      if (localStorageValue) {
        const userInfo: any = JSON.parse(localStorageValue);
        userInfo.user = endUserInfo;
        localStorage.setItem("userInfo", JSON.stringify(userInfo));
        window.location.reload();
      }
    }
  }, [endUserInfo])

  // const logoutUser = useMutation({
  //   mutationFn: () => logout(),
  //   onSuccess: async () => {
  //     await localStorage.removeItem("userInfo");
  //     window.location.reload();
  //   },
  // });

  const handleSubmit = async (ev: React.MouseEvent<HTMLButtonElement>) => {
    ev.preventDefault();
    // logoutUser.mutateAsync();
    await localStorage.removeItem("userInfo");
    window.location.reload();
  };

  return (
    <div className="flex items-center self-center justify-center min-h-[calc(100vh-56px)] w-full bg-brand">
      {dialogue ? (
        <>
          {openPayment ? (
            <PaymentScreen
              onGoback={() => {
                navigate(-1);
              }}
              clientSecret={paymentData?.client_secret}
              onSuccess={() => {
                displaySuccess("Payment has been completed. You can now login to you account!");
                refetch()
              }}
              priceInfo={paymentData}
            />
          ) : (
            <div className="flex items-center justify-center">
              <GlimpseCard className="min-w-[330px] max-w-[347px] h-[100px] bg-white p-4">
                <div className="text-xl text-brand">
                  It looks like your membership has expired!
                </div>
                <span className="text-text-heading">
                  Hurry! Don't lose access.
                </span>

                <div className="flex justify-between w-full gap-3 pt-10">
                  <Button
                    variant="outline"
                    onClick={(ev: React.MouseEvent<HTMLButtonElement>) =>
                      handleSubmit(ev)
                    }
                    className="w-[110px]"
                  >
                    No Thanks
                  </Button>
                  <Button
                    variant="primary"
                    onClick={() => setOpenPayment(true)}
                    className="w-[122px]"
                  >
                    Renew Now!
                  </Button>
                </div>
              </GlimpseCard>
            </div>
          )}
        </>
      ) : paymentData?.client_secret ? (
        <PaymentScreen
          onGoback={async () => {
            await logout();
            localStorage.removeItem("userInfo");
            window.location.reload();
          }}
          clientSecret={paymentData?.client_secret}
          onSuccess={() => {
            displaySuccess("Payment has been completed. You can now login to your account!");
            refetch()
          }}
          priceInfo={paymentData}
        />
      ) : (
        <div className="flex items-center justify-center w-full">
          <Loading />
        </div>
      )}
    </div>
  );
};

export default RenewSubscription;
